import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=3ad9e637&"
import script from "./AttachmentUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentUploader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentUploader.vue?vue&type=style&index=0&id=3ad9e637&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports